import { useAdvanceTableContext } from '@aibees/shared/features/advance-table/context';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { TableLoadingSpinnerProps as Props } from './types';

const arkLogoSlotProps = {
  img: {
    fetchPriority: 'high',
  } as React.ImgHTMLAttributes<HTMLImageElement>,
};

export const TableLoadingSpinner = memo(({ className }: Props) => {
  const { config } = useAdvanceTableContext();

  return (
    <Styled.Wrapper
      className={classnames('TableLoadingSpinner', className)}
      sx={SX.root}
    >
      <Styled.LoadingContainer>
        <Styled.Spinner />
        <Styled.ArkLogo
          src="/assets/images/ark-logo.svg"
          slotProps={arkLogoSlotProps}
        />
        <Styled.LoadingBg />
      </Styled.LoadingContainer>

      <Styled.LoadingText variant="body4">
        {config?.loadingText || 'Loading...'}
      </Styled.LoadingText>
    </Styled.Wrapper>
  );
});

TableLoadingSpinner.displayName = 'TableLoadingSpinner';
